import { useQuery } from 'react-query';

import { handleRefreshToken } from 'utils/refreshToken';
import { API_URL, HEADER_ACCEPT_HR } from 'utils/apiConstants';
import { ListCompanyPermissionResourcesResponsesByAccept } from '@bestdoctor/core-arch-api/api/company-permissions/types';
import { GetPermissionsData, GetPermissionsParams } from 'interfaces/hooks/permissionsHooksInterfaces';
import { FetchError } from 'utils/FetchError';

export const useGetPermissions = ({ isLoggedIn, onError }: GetPermissionsParams): GetPermissionsData => {
  const { data: permissionsData } = useQuery(
    ['permissions'],
    async () => {
      await handleRefreshToken();

      const token = localStorage.getItem('token');

      const res = await fetch(`${API_URL}/company_permissions/`, {
        method: 'GET',
        headers: {
          Accept: `${HEADER_ACCEPT_HR}`,
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        return res.json();
      }
      throw new FetchError(res);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      enabled: isLoggedIn,
      onError,
      onSuccess: (res: ListCompanyPermissionResourcesResponsesByAccept['application/vnd.bestdoctor.v1-hr']) => {
        sessionStorage.setItem('company_permissions', JSON.stringify(res?.data));
      },
    }
  );

  return {
    permissionsData,
  };
};
